import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { showToast, ToastType } from "../../utils/ToastUtil";
import { useToast } from "../../context/Toast/ToastProvider";
import {
  GetMedicalStudiesOnlyNames,
  GetPetImages,
  GetSanitariesRecordOnlyNames,
} from "../../services/petService";
import { useStateAuthValue } from "../../context/Auth/AuthState";

export const GetBackgroundData = ({ petFromEdit }) => {
  const { setFieldValue } = useFormikContext();
  const [{ userToken }] = useStateAuthValue();
  const toastDispatch = useToast();

  const getImages = async (petId) => {
    try {
      const images = await GetPetImages(petId, userToken);
      if (images.status === 200) {
        return images.data;
      }
      return [];
    } catch (error) {
      return [];
    }
  };

  const GetMedicalStudies = async () => {
    const petId = petFromEdit.id;
    return await GetMedicalStudiesOnlyNames(petId, userToken);
  };

  const GetSanitariesRecord = async () => {
    const petId = petFromEdit.id;
    return await GetSanitariesRecordOnlyNames(petId, userToken);
  };

  const getHeavyData = () => {
    if (petFromEdit) {
      const petId = petFromEdit.id;
      const imagesPromise = getImages(petId, userToken);
      const medicalStudies = GetMedicalStudies(petId, userToken);
      const sanitariesRecord = GetSanitariesRecord(petId, userToken);

      imagesPromise
        .then((images) => {
          const imageAdult = images.find((e) => e.type === "ADULT");
          const imagePuppy = images.find((e) => e.type === "PUPPY");
          setFieldValue(
            "urlPuppy",
            imagePuppy ? `data:image/png;base64,${imagePuppy.photo}` : ""
          );
          setFieldValue(
            "urlAdult",
            imageAdult ? `data:image/png;base64,${imageAdult.photo}` : ""
          );
        })
        .catch(() => {
          showToast(toastDispatch, "Error loading pet images", ToastType.ERROR);
        });

      medicalStudies
        .then((studies) => {
          const studiesFormat = studies.data.map((study) => {
            const extension = study?.filename
              ? study.filename.split(".").pop() ?? "unknown"
              : "unknown";

            return {
              id: study.id,
              filename: study.filename,
              name: study.filename,
              type: extension,
            };
          });
          setFieldValue("medicalStudies", studiesFormat);
        })
        .catch(() => {
          showToast(
            toastDispatch,
            "Error loading medical studies",
            ToastType.ERROR
          );
        });

      sanitariesRecord
        .then((healthBook) => {
          const filesHealthBookletFormat = healthBook.data.map((study) => {
            const extension = study?.filename
              ? study.filename.split(".").pop() ?? "unknown"
              : "unknown";

            return {
              id: study.id,
              filename: study.filename,
              name: study.filename,
              type: extension,
            };
          });
          setFieldValue("healthBooklet", filesHealthBookletFormat);
        })
        .catch(() => {
          showToast(
            toastDispatch,
            "Error loading health booklet",
            ToastType.ERROR
          );
        });
    }
  };
  useEffect(() => {
    getHeavyData();
  }, []);
  return null;
};
